<template>
    <div class="w-full p-6 relative overflow-auto h-screen ">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "TemplatePage",
        
    }
</script>